import type { Score } from './types';

export type ArsenalSide = 'home' | 'away';

export function arsenalIsAway(venue: string | undefined, side?: ArsenalSide): boolean {
  return venue === 'A' || (venue === 'N' && side === 'away');
}

export function arsenalScore(
  score: Score | null | undefined,
  venue: string | undefined,
  side?: ArsenalSide,
): { ours: number; theirs: number } | null {
  if (!score) return null;
  return arsenalIsAway(venue, side)
    ? { ours: score.away, theirs: score.home }
    : { ours: score.home, theirs: score.away };
}
